import { Grid } from "@mui/material";
import { LatestAttempt } from "./LatestAttempt";
import { useAppSelector } from "../../redux";
import { selectAttempts } from "./QueueSlice";
import { Attempt } from "./Attempt";
import { StartQueue } from "./StartQueue";
import { FullScreenImage } from "./FullScreen";
import { useState } from "react";

export function Queue() {
  const [fullScreen, setFullScreen] = useState<boolean>(false);
  const [attemptIndex, setAttemptIndex] = useState<number>(0);
  const attempts = useAppSelector(selectAttempts);

  return (
    <Grid justifyContent={"center"} alignItems={"top"} spacing={3} container>
      {fullScreen ? (
        <FullScreenImage handleClose={() => setFullScreen(false)} fullScreen={fullScreen} attempt={attemptIndex} />
      ) : null}
      {!attempts || !attempts.length ? (
        <Grid item xs={12} xl={12}>
          <StartQueue />
        </Grid>
      ) : (
        <Grid item xs={12} xl={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} xl={12} sx={{ marginBottom: 10 }}>
              <LatestAttempt setFullScreen={setFullScreen} attempt={attempts[0]} setAttemptIndex={setAttemptIndex} />
            </Grid>

            {attempts.map((attempt, i) => {
              if (i === 0) {
                return null;
              }
              return (
                <Grid item xs={4} xl={4} sx={{ marginBottom: 10 }}>
                  <Attempt
                    attempt={attempt}
                    key={i}
                    index={i}
                    setAttemptIndex={setAttemptIndex}
                    setFullScreen={setFullScreen}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
